// extracted by mini-css-extract-plugin
export default {"primaryColor":"#6457c6","primaryColorWithAlpha":"rgba(100,87,198,.1019607843)","mainBgColor":"#fafaf8","secondBgColor":"#f0f0f0"};